import {
  DeviceModeType,
  deviceModes,
  useDeviceModeContext,
} from 'client/context/DeviceModeContext'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { components, SingleValueProps } from 'react-select'
import { Monitor01Icon } from 'src/editor/shared/icons/monitor-01-icon'
import { Phone01Icon } from 'src/editor/shared/icons/phone-01-icon'
import {
  OptionType,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import { twMerge } from 'tailwind-merge'

interface DeviceModeSelectProps {
  className?: string
}

export const DeviceModeSelect = ({ className }: DeviceModeSelectProps) => {
  const { setDeviceMode, deviceMode } = useDeviceModeContext()
  const { t } = useTranslation()
  const options: OptionType<DeviceModeType>[] = [
    {
      value: deviceModes.Desktop,
      label: t('settings_options.device_appearance.desktop'),
    },
    {
      value: deviceModes.Mobile,
      label: t('settings_options.device_appearance.mobile'),
    },
  ]
  const getSelectedOption = () => {
    return options.find(el => el.value === deviceMode) ?? options[0]
  }
  return (
    <SelectNew<DeviceModeType>
      wrapperClassName={twMerge('mb-4 w-[130px]', className)}
      options={options}
      onChange={option => setDeviceMode(option?.value ?? deviceModes.Desktop)}
      selectedOption={getSelectedOption()}
      components={{ SingleValue }}
      isSearchable={false}
    />
  )
}

const SingleValue = (
  props: SingleValueProps<OptionType<DeviceModeType>, false>,
) => {
  const { data } = props

  return (
    <components.SingleValue
      {...props}
      className={twMerge(props.className, 'flex items-center gap-1.5')}
    >
      {data.label === deviceModes.Desktop ? (
        <Monitor01Icon
          width={16}
          height={16}
          className="[&>path]:fill-iconSecondary"
        />
      ) : (
        <Phone01Icon
          width={16}
          height={16}
          className="[&>path]:fill-iconSecondary"
        />
      )}
      <span>{data.label}</span>
    </components.SingleValue>
  )
}
